import React from 'react';

const FormAssignmentTab = ({ active, newForm, usageFields, renderUsageField }) => (
  <div className={`tab-pane fade ${active ? 'show active' : ''}`} role="tabpanel">
    <h6 className="mb-2">{newForm.name}</h6>
    <p className="text-secondary-light mb-4">Choose which departments, teams, roles, asset classes and asset groups have access to the form. </p>
    <div className="row g-3">{usageFields.map(renderUsageField)}</div>
  </div>
);

export default FormAssignmentTab;
